<template>
  <div>

    <div class="mx-sm-8">

      <v-card flat>
        <v-card-title class="headline">
          Filters
        </v-card-title>
        <v-card-text>

          <v-checkbox hide-details class="my-0" v-model="filter.failed_emails">
            <template v-slot:label>
              <div>
                Registraties met mislukte e-mails
              </div>
            </template>
          </v-checkbox>

          <p v-if="userEmail === 'peter@wemagine.nl'" class="mt-4">Todo: Filter op start + einddatum toevoegen die standaard op afgelopen week staat om laad snelheid te verbeteren.</p>

        </v-card-text>
      </v-card>

      <v-data-table
          :headers="headers"
          :items="registrations"
          class="mt-3 rounded-lg"
          mobile-breakpoint="0"
          :items-per-page="20"
          :page.sync="page"
          :loading="loading"
          hide-default-footer
          @click:row="rowClick"
      >
        <template #item.form_name="{ item }">

          <!-- Add warning icon is registration has failed emails (registration.email_hooks.0.hook_status) -->
          <v-icon
              v-if="item.email_hooks && item.email_hooks.length > 0 && item.email_hooks[0].hook_status === 'error'"
              color="error"
              dense
              class="ml-1"
              title="Deze registratie heeft mislukte e-mails"
          >mdi-email-alert</v-icon>

          {{ item.form_name }}

        </template>
        <template #item.form_summary="{ item }">
          <div
              class="form-summary"
              v-if="item.form_summary"
              v-html="replaceTokens(item.form_summary, getTokensFromSchema(item.schema), item.values, true, item.schema)"
          ></div>
        </template>
        <template #item.registration_date="{ item }">
          {{ item.registration_updated_at|formatDate }}
        </template>
      </v-data-table>

      <div class="text-center pt-2">
        <v-pagination
            :disabled="loading"
            v-model="page"
            :length="pageCount"
            :total-visible="9"
        ></v-pagination>
      </div>

    </div>



    <v-container fluid class="pa-md-8 pt-md-2" v-if="registrations.length === 0">
      <v-row>
        <v-col>
          Er zijn nog geen registraties gedaan.
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="registrationModal" max-width="700" scrollable>
      <v-card>
        <v-card-title>Bekijk registratie</v-card-title>
        <v-card-text v-if="registration">
          <registration-view :registration="registration" :form="registration"></registration-view>
        </v-card-text>
        <v-card-actions>
          <v-btn depressed color="primary" @click="closeRegistrationModal">Sluit</v-btn>
<!--          <v-btn outlined color="secondary" @click.stop="fillFormAgain(registration)">Opnieuw invullen <v-icon small class="ml-1">mdi-refresh</v-icon></v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import eformHelpers from "@/mixins/eformHelpers";
import axios from "axios";
import RegistrationView from "@/components/RegistrationView.vue";

export default {
  name: "RegistrationsAdminList",
  components: {
    RegistrationView,
  },
  mixins: [
    eformHelpers
  ],
  data () {
    return {
      registrations: [],
      loading: false,
      page: 1,
      pageCount: 0,
      registrationModal: false,
      registration: null,
      headers: [
        {
          text: 'Formulier naam',
          sortable: false,
          align: 'start',
          value: 'form_name',
        },
        {
          text: 'Samenvatting',
          sortable: false,
          align: 'start',
          value: 'form_summary',
        },
        {
          text: 'Gebruiker',
          sortable: true,
          value: 'registration_user.username'
        },
        {
          text: 'Registratie datum',
          sortable: false,
          align: 'start',
          value: 'registration_date',
        },
      ],
      filter : {
        failed_emails: false,
      },
    }
  },
  computed : {
    userEmail() {
      return this.$store.getters.getUserEmail;
    },
  },
  // Watch the page variable, load new results when it changes
  watch: {
    page (newPage) {
      // Load new results
      this.loadRegistrations(newPage)
    },
    'filter.failed_emails'() {
      // Reset to first page
      this.page = 1
      // Load new results
      this.loadRegistrations(1)
    },
  },
  mounted () {
    // Load the first page
    this.loadRegistrations(1)
  },
  methods: {
    rowClick(item) {
      this.openRegistrationModal(item)
    },
    async loadRegistrations(page = 1) {
      this.scrollToTop();

      let config = {
        params: {
          'page': page - 1, // API is zero-based
          // 'sort': '-registration_date', // Sort in descending order by appending a minus
          'f[failed_emails]': this.filter.failed_emails,
        }
      }
      this.loading = true
      // Fetch results form the API
      await axios
          .get('api/admin/registrations', config)
          .then(response => {
            this.registrations = response.data.registrations
            this.pageCount = response.data.pages_count;
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.loading = false
          })
    },
    scrollToTop() {
      window.scrollTo(0,0);
    },
    openRegistrationModal(item) {
      this.registration = item
      this.registrationModal = true
    },
    closeRegistrationModal() {
      this.registration = null
      this.registrationModal = false
    },
  },
}
</script>

<style scoped>

</style>